export default __webpack_public_path__ + "static/O0078-df94607b2737c50157c46040a14a30eb.png";